var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "response" }, [
    _c(
      "div",
      { staticClass: "response__image" },
      [
        _c(
          "router-link",
          {
            attrs: {
              to: {
                name: "view-user",
                params: { user_id: _vm.response.user.id },
              },
            },
          },
          [
            _c("img", {
              staticClass: "avatar avatar--small",
              attrs: { src: `/images/avatar/${_vm.response.user.id}` },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.response.createdAt)),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "response__content" }, [
      _c("h3", [_vm._v(_vm._s(_vm.response.user.name))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.response.user.member.name))]),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.response.content) } }),
      _vm._v(" "),
      _vm.response.attachments
        ? _c(
            "ul",
            { staticClass: "response__documents" },
            _vm._l(_vm.response.attachments, function (doc) {
              return _c(
                "li",
                [_c("AttachmentDownload", { attrs: { attachment: doc } })],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.response.user.id === _vm.user.id
      ? _c("div", { staticClass: "response__actions" }, [
          _c("ul", { staticClass: "actions" }, [
            _c("li", [
              _c(
                "button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.editResponse.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("svg", { staticClass: "svg-icon" }, [
                    _c("use", { attrs: { "xlink:href": "#icon--edit" } }),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "button",
                {
                  staticClass: "action",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showDeleteModal.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("svg", { staticClass: "svg-icon" }, [
                    _c("use", { attrs: { "xlink:href": "#icon--delete" } }),
                  ]),
                ]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }